import { throttle } from '../../util/function'
import {
  backendPaddingMobileBottomDiff,
  backendPaddingDesktopBottomDiff,
  tabletMinWidth
} from '../../../css/redesign/exports/misc.scss'

const backendMainContentSelector = '.js-backend_main_content'
const elementsBeforeMainContentSelector = '.js-before_backend_main_content'
// the desired design is so that "the footer only appears soonest after 100dvh", so
// we need the backend main content to have min-height of 100dvh minus the top nav

const setBackendMainContentMinHeight = throttle(function () {
  const element = document.querySelector(backendMainContentSelector)
  // some pages with the cookie consent warning banner don't have this element
  if (!element) {
    return
  }

  const windowWidth = window.innerWidth || document.documentElement.clientWidth
  const elementsBeforeMainContent = window.document.querySelectorAll(elementsBeforeMainContentSelector)
  const elementsBeforeMainContentTotalHeight = Array.from(elementsBeforeMainContent).reduce(
    (acc, x) => acc + x.getBoundingClientRect().height,
    0
  )

  // the element has a bigger bottom padding than top padding
  // to make sure that full-height content is vertically centered on the first screen (when scrolled to the very top,
  // we're adding back the difference between top and bottom padding so that it can only be seen after scrolling
  let paddingDiff =
    windowWidth < parseInt(tabletMinWidth, 10) ? backendPaddingMobileBottomDiff : backendPaddingDesktopBottomDiff

  const footer = document.querySelector('.js-footer') || document.querySelector('.js-small_footer')

  // on some pages (e.g. DMs) the footer is rendered, but only visible on desktop
  if (!footer || footer.getBoundingClientRect().height === 0) {
    paddingDiff = 0
  }

  const heightDiff = elementsBeforeMainContentTotalHeight - parseInt(paddingDiff, 10)
  element.style.minHeight = `calc(100dvh - ${heightDiff}px)`
}, 100)

up.compiler(backendMainContentSelector, function () {
  window.addEventListener('resize', setBackendMainContentMinHeight)
  setBackendMainContentMinHeight()

  return function () {
    window.removeEventListener('resize', setBackendMainContentMinHeight)
  }
})
